import { http } from '../api/http';

export interface DeveloperProjectSummary {
  id: string;
  name: string;
  status: string;
  fundedPct: number;
  fundedAmount: number;
  targetAmount: number;
  investorsCount: number;
  fundingStart?: string | null;
  fundingEnd?: string | null;
  requiredDocumentsCount: number;
  uploadedDocumentsCount: number;
  approvedDocumentsCount: number;
  pendingDocumentsCount: number;
  observedDocumentsCount: number;
  missingDocumentsCount: number;
  documentsApproved: boolean;
}

export interface DeveloperProjectDetail extends DeveloperProjectSummary {
  fundingTimeline?: { date: string; amount: number }[];
  milestones?: { label: string; date: string }[];
}

export const DeveloperDashboardService = {
  getMyProjects() {
    return http<DeveloperProjectSummary[]>('/developer/projects');
  },

  getProjectDetail(id: string | number) {
    return http<DeveloperProjectDetail>(`/developer/projects/${id}`);
  },
};
